import './Links.css';

function Links() {
  return (
    <div className="links">
      <a href="https://www.linkedin.com/in/duhoshina/" target="_blank">Linkedin</a>
      <a href="https://github.com/duhoshina" target="_blank">Github</a>
      <a href="https://github.com/duhoshina/reactlol-gg" target="_blank">Acessar repositorio</a>
    </div>
  )
}

export default Links